export default {
  headerContent: {
    title: 'Bereket Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Bereket Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Zorunlu trafik sigortası motorlu taşıt sahibinin yaptırması zorunlu olan sigorta ürünüdür.',
        'Trafik sigortası karayolunda oluşabilecek kaza sonucunda karşı tarafa ve 3. Şahıslara verilen hasarları poliçede belirtilen limitler dâhilinde karşılamaktadır.'
      ]
    },
    subContent: {
      title:
        'Bereket Sigorta Zorunlu Trafik Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Bereket Sigorta’nın sunmuş olduğu standart poliçede;',
          subList: [
            'Maddi Zararlar Teminatı',
            'Sağlık Giderleri Teminatı',
            'Sürekli Sakatlık Teminatı',
            'Vefat Teminatı bulunmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Bereket Sigorta Zorunlu Trafik Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta müşterilerine standart poliçeye ek olarak alabilecekleri çekici hizmeti paketi de sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Zorunlu Trafik Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph: 'Poliçeye ek bir sözleşme ile dâhil edilmemesi durumunda;',
          subList: [
            'Çekici hizmeti',
            'Sigortalının aracında oluşacak hasarlar',
            'Sigortalı aracın veya içerindeki eşyaların çalınması',
            'Manevi tazminat talepleri',
            'Aracın değer kaybı teminat dışı sayılmaktadır.'
          ]
        },
        {
          paragraph:
            'Karşı tarafa verilen hasarın o yıl içinde belirlenmiş olan limitlerin üstünde olması durumunda poliçe kapsamından karşılanmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Trafik Sigortası Bitiş Tarihi Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Bereket Sigorta’da bulunan trafik poliçenizin bitiş tarihini öğrenmek için e-devlet üzerinden araçlarım sayfasından veya 0216 371 67 77 numaralı hattan bizimle iletişime geçerek poliçenizin bitiş tarihini kolayca öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Hasar Anında İstenen Belgeler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kaza tespit tutanağı',
            'Anlaşmalı tutanak olmadığı takdirde kolluk kuvvetleri tarafından tutulmuş rapor.',
            'Alkol raporu',
            'Kazaya karışan araçların ruhsatları ve sürücülerin ehliyetleri',
            'Mağdur araç sahibinin hesap bilgileri istenir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Trafik Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Trafik sigortası primleri sigortalının geçmiş kullanımları, araç bilgileri ve araç plaka koduna göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Bereket Sigorta’dan trafik sigortası fiyatı almak isteyen müşterilerimiz Alokasko.com üzerinden başvuru formu doldurarak trafik sigortası hakkında detaylı bilgi alabilir. ',
          subList: null
        },
        {
          paragraph:
            'Uzman danışmanlarımızın sunmuş olduğu teklifi değerlendirerek poliçesini kolayca satın alabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigortadan Trafik Sigortasını Kaç Taksitle Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Bereket Sigorta kredi kartınıza 9 aya kadar vadeli olarak poliçe oluşturmaktadır. Taksit seçeneği bankalar arası farklılık gösterebilmektedir.',
          subList: null
        },
        {
          paragraph:
            'En ucuz trafik sigortası fiyatı için hemen online teklif alın.',
          subList: null
        }
      ]
    }
  ]
}
